import PropTypes from 'prop-types';
import { Dialog } from 'primereact/dialog';
import { useTranslation } from 'react-i18next';
import { Splitter, SplitterPanel } from 'primereact/splitter';
import { Divider } from 'primereact/divider';
import { Message } from 'primereact/message';
import { formatDatetime } from 'utils/func';
import ViewHistoricalPersonnelAdjustmentItem from './VIewHistoricalPersonnelAdjustmentItem';

export default function ViewHistoricalPersonnelAdjustment({
  visible,
  setVisible,
  generalInfoData,
  isLoading,
  formatIndex,
  formatFullname,
  formatGender,
  formatResearcherOrganization,
}) {
  const { t } = useTranslation();
  const formatHeader = () => (
    <div>
      <p className="text-blue-500">
        {t('projectProposal.viewHistoricalPersonnelAdjustment.title')}
      </p>
      {generalInfoData?.length > 0 && (
        <div className="flex justify-content-around detail-info-project-proposal">
          <h4>{t('projectProposal.viewHistoricalPersonnelAdjustment.oldMembers')}</h4>
          <h4>{t('projectProposal.viewHistoricalPersonnelAdjustment.newMembers')}</h4>
        </div>
      )}
    </div>
  );

  const formatApproveAdjustmentDate = (data) => (
    <div>
      {t('projectProposal.viewHistoricalPersonnelAdjustment.adjustmentApprovalDate')}
      {': '}
      {formatDatetime(data?.reviewedAt, 'DD/MM/YYYY HH:mm:ss')}
    </div>
  );
  return (
    <Dialog
      header={formatHeader()}
      visible={visible}
      position="center"
      style={{ width: '90vw' }}
      onHide={() => setVisible(false)}
      draggable={false}
    >
      {generalInfoData?.map((members) => (
        <>
          <Message severity="info" text={formatApproveAdjustmentDate(members)} />
          <Splitter className="detail-info-project-proposal mt-2">
            <SplitterPanel className="p-4">
              <ViewHistoricalPersonnelAdjustmentItem
                members={members?.oldMembers}
                isLoading={isLoading}
                formatIndex={formatIndex}
                formatFullname={formatFullname}
                formatGender={formatGender}
                formatResearcherOrganization={formatResearcherOrganization}
              />
            </SplitterPanel>
            <SplitterPanel className="p-4">
              <ViewHistoricalPersonnelAdjustmentItem
                members={members?.newMembers}
                isLoading={isLoading}
                formatIndex={formatIndex}
                formatFullname={formatFullname}
                formatGender={formatGender}
                formatResearcherOrganization={formatResearcherOrganization}
              />
            </SplitterPanel>
          </Splitter>
          <Divider />
        </>
      ))}
    </Dialog>
  );
}

ViewHistoricalPersonnelAdjustment.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  generalInfoData: PropTypes.arrayOf(PropTypes.object).isRequired,
  isLoading: PropTypes.bool.isRequired,
  formatIndex: PropTypes.func.isRequired,
  formatFullname: PropTypes.func.isRequired,
  formatGender: PropTypes.func.isRequired,
  formatResearcherOrganization: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
};
